import React from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import MediaLibrary from "../../MediaLibrary";
import { useMediaStudio } from "../../context/MediaStudioContext";
import { SectionRoot, SectionTitle, SectionSub } from "../shared";

// Media assets + composed projects. MediaLibrary owns the assets/projects
// toggle internally; this section just gives it a routed home.

const Frame = styled.div`
  width: 100%;
  background: var(--color-surface);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
  padding: var(--space-5);
  min-height: 60vh;
`;

export const LibrarySection: React.FC = () => {
  const { communityId } = useMediaStudio();
  const location = useLocation();
  const folder = new URLSearchParams(location.search).get("folder");

  return (
    <SectionRoot>
      <div>
        <SectionTitle>Library</SectionTitle>
        <SectionSub>
          Your media assets and the carousels and reels composed from them.
        </SectionSub>
      </div>
      <Frame>
        <MediaLibrary key={`${communityId}:${folder}`} communityId={communityId} initialFolder={folder} />
      </Frame>
    </SectionRoot>
  );
};

export default LibrarySection;
